/** Cómo se nombra cada audiencia, en un solo lugar.
 *
 *  HABÍA CUATRO COPIAS DE ESTE MAPA —en la página, en el paso 3, en la lista de
 *  borradores y en la de programadas— y ya habían divergido: dos decían «Todo
 *  CRM» y «Por curso» donde las otras decían «Todos los contactos CRM» y «Por
 *  materia». Ninguna de las cuatro incluía `active_term_students`, así que ese
 *  segmento se mostraba con su clave cruda en las tablas.
 *
 *  Un mapa duplicado no se rompe: se desincroniza, que es peor, porque la misma
 *  campaña se llama distinto según la pantalla desde la que se mire.
 */
export const AUDIENCE_LABELS: Record<string, string> = {
  all_crm: 'Todos los contactos CRM',
  tag: 'Por etiqueta CRM',
  by_person_type: 'Por tipo de persona',
  by_institutional_role: 'Por cargo institucional',
  by_program: 'Por programa de estudio',
  by_course: 'Por materia',
  active_term_students: 'Alumnos del período activo',
  custom_contacts: 'Selección personalizada',
};

/** La etiqueta, o la clave si es un segmento que este código no conoce —
 *  preferible a una celda vacía que no dice nada. */
export function audienceLabel(type: string | undefined): string {
  if (!type) return '—';
  return AUDIENCE_LABELS[type] ?? type;
}
